module.exports = __webpack_public_path__ + "static/blue-logo-10348c38b521481d3a6a1a3d9d2158df.png";